import {ImageRequestParams} from "../../../infrastructure/models/params/image-request-params";

export class SponsorshipLogoParams extends ImageRequestParams {
  constructor(name: String, isCircle: Boolean) {
    super({resourceName: `Website/Sponsorships`});

    this.resourceName = `Website/Sponsorships/${isCircle ? 'Mobile' : 'Desktop'}/${name}`
  }
}
